export const picnicDisclaimerDataContent = [
  {
    type: "para",
    dataHeader: "Before You Begin",
    content: [
      "To ensure a safe and enjoyable experience, we recommend that you review the important resources linked below before starting the game.",
      "These links provide valuable information and context related to the ingredients, safety guidelines, and usage terms involved in the Picnic Recipe Making Game.",
      "If you're not reading them now, please acknowledge that you agree to review them later by accepting our disclaimer.",
    ],
  },

  {
    type: "link",
    dataHeader: "Sources",
    content: [
      {
        head: "How to Make Healthy and Delicious Smoothies",
        body: "https://health.clevelandclinic.org/how-to-make-healthy-and-delicious-smoothies",
      },
      {
        head: "The Whole Truth About Whole Grains",
        body: "https://health.clevelandclinic.org/the-whole-truth-about-whole-grains",
      },
      {
        head: "High-Cholesterol Foods to Eat and Avoid",
        body: "https://health.clevelandclinic.org/high-cholesterol-foods-to-eat-and-avoid",
      },
      {
        head: "Is Red Meat Bad for You?",
        body: "https://health.clevelandclinic.org/is-red-meat-bad-for-you",
      },
      {
        head: "6 Easy Steps to Healthy Burgers You'll Love",
        body: "https://health.clevelandclinic.org/6-easy-steps-to-healthy-burgers-youll-love-infographic",
      },
      {
        head: "Making Healthier Fast-Food Choices",
        body: "https://magazine.clevelandclinic.org/2024-summer/making-healthier-fast-food-choices",
      },
      {
        head: "How to Eat Healthy at Your Favorite Restaurants",
        body: "https://health.clevelandclinic.org/how-to-eat-healthy-at-your-favorite-restaurants",
      },
      {
        head: "Are Chickpea, Black Bean and Soy Bean Pastas Healthier Picks?",
        body: "https://health.clevelandclinic.org/are-chickpea-black-bean-and-soy-bean-pastas-healthier-picks",
      },
      {
        head: "Tips To Make Your Pizza Heart-Healthy",
        body: "https://health.clevelandclinic.org/how-to-make-healthy-pizza",
      },
    ],
  },
];
